<template>
  <div
    class="fou-uploader"
    :class="imageErrors?.length && !loading ?'fou-uploader--error':''"
  >
    <div
      class="fou-uploader__content"
    >
      <AnimationProcessing
        v-if="loading"
        class="fou-uploader__loader"
      />
      <UploadIcon
        v-else
        id="upload-icon"
        data-qa-id="upload-icon"
      />
      <p
        v-if="!loading"
        id="upload-text"
        class="mt-e-para"
        data-qa-id="upload-text"
        v-html="dragText"
      />
    </div>
    <input
      id="file-upload"
      type="file"
      name="bundle image"
      class="mt-input"
      accept=".png, .jpg, .jpeg"
      multiple
      :value="files"
      data-qa-id="file-upload"
      title="File input"
      :disabled="loading"
      @change="event => upload(event)"
    >
    <div
      v-if="imageErrors?.length && !loading"
      id="error-message"
      class="mt-error"
      data-qa-id="error-message"
    >
      {{ errors[props.name] }}
    </div>
  </div>
</template>

<script src="./index.js" />

<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/breakpoints';

.fou-uploader {
  width: 100%;
  position: relative;
  border: 1px dashed map-get($colors, 'spirits--500');
  border-radius: 16px;

  &__content {
    position: absolute;
    border-radius: 16px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 24px;
    text-align: center;

    .mt-e-para {

      .mt-link {
        text-decoration: underline;
      }
    }
  }

  &__loader {
    height: 50px;
    width: 50px;
  }

  &--error {

    .mt-error {
      position: absolute;
      top: calc(100% + 8px);
      font-size: 13px;
      margin-left: 0;
    }
  }

  .mt-input {
    height: 264px;
    border: 0;
    opacity: 0;
    position: relative;
    z-index: 2;
    cursor: pointer;
    width:100%;
    border-radius: 16px;

    @media screen and (max-width: map-get($breakpoints, 's'))  {
      height: 232px;
    }

    &:not(.mt-input--block)+* {
     margin-left: 0;
    }
  }

  &.fou-uploader--error {
    border: 1px dashed map-get($colors, 'red-babe--500');
  }
}
</style>
